<template>
  <div class="home">

    <section
      id="home-intro"
      class="home__intro home__section"
    >
      <div class="container">
        <div class="home__section-row">
          <div class="home__intro__image col-lg-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="291"
              height="363"
            >
              <path
                fill="none"
                fill-rule="evenodd"
                stroke="#E8E6E6"
                stroke-width="4"
                d="M90.4 2.87C200 2.82 288.82 91.63 288.76 201.23c-.04 87.68-71.15 158.8-158.83 158.84-70.15.03-126.99-56.8-126.95-126.95C3 177 48.52 131.49 104.63 131.46a81.2 81.2 0 0 1 81.25 81.25 65.1 65.1 0 0 1-65.06 65.06 51.96 51.96 0 0 1-52-52 41.67 41.67 0 0 1 41.64-41.64 33.26 33.26 0 0 1 33.28 33.28 26.67 26.67 0 0 1-26.65 26.65"
              />
            </svg>
          </div>
          <div class="home__intro__details col-lg-6">
            <h1
              v-t="'p.home.section.intro.title'"
              class="home__intro__headline home__typo-h1"
            />
            <p class="home__intro__text home__typo-text">
              {{ $t('p.home.section.intro.message.description') }}
              <router-link
                v-t="'p.home.section.intro.label.features'"
                :to="{ name: 'Home', hash: '#home-features' }"
                class=""
              />
            </p>
            <div class="home__intro__details__footer">
              <router-link
                v-t="'p.home.section.intro.label.demo'"
                :to="{ name: 'Home', hash: '#home-demo' }"
                class="home__intro__button button button--1"
              />
              <span class="">
                {{ $t('p.home.section.intro.message.signin') }}
                <router-link
                  v-t="'p.home.section.intro.label.signin'"
                  :to="{ name: 'SignInPage' }"
                  class="text-underline"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      id="home-testimonials"
      class="home__testimonials home__section background-muted"
    >
      <div class="container">
        <div class="row">
          <div class="home__section-heading col-lg-8 offset-lg-2">
            <h2
              v-t="'p.home.section.testimonials.title'"
              class="home__typo-h2 text-center"
            />
            <p
              v-t="'p.home.section.testimonials.message.description'"
              class="home__typo-text text-center"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 offset-lg-1">
            <p
              class="home__testimonials__quote"
              v-text="testimonial.quote"
            />
          </div>
          <div class="home__testimonials__author col-xs-11 col-lg-10">
            <div class="">
              <div
                class="home__testimonials__author__name"
                v-text="testimonial.name"
              />
              <div
                class="home__testimonials__author__position"
                v-text="testimonial.position"
              />
            </div>
            <div class="home__testimonials__author__avatar">
              <img
                :src="testimonial.imgSrc"
                :alt="testimonial.name"
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      id="home-overview"
      class="home__overview home__section"
    >
      <div class="container">
        <div class="home__section-heading col-lg-8 offset-lg-2">
          <h2
            v-t="'p.home.section.overview.title'"
            class="home__typo-h2 text-center"
          />
          <p
            v-t="'p.home.section.overview.message.description'"
            class="home__typo-text text-center"
          />
        </div>
        <div class="home__overview__grid home__section-row col-lg-12">
          <div class="home__overview__grid-item  col-xs-12 col-sm-6 col-xl-3">
            <div class="home__overview__grid-item__wrap">
              <div class="home__overview__grid-item__content">
                <font-awesome-icon
                  icon="inbox"
                  class="home__overview__grid-item__image"
                />
                <p v-t="'p.home.section.overview.message.import'" />
              </div>
            </div>
          </div>
          <div class="home__overview__grid-item  col-xs-12 col-sm-6 col-xl-3">
            <div class="home__overview__grid-item__wrap">
              <div class="home__overview__grid-item__content">
                <font-awesome-icon
                  icon="pencil-alt"
                  class="home__overview__grid-item__image"
                />
                <p v-t="'p.home.section.overview.message.create'" />
              </div>
            </div>
          </div>
          <div class="home__overview__grid-item  col-xs-12 col-sm-6 col-xl-3">
            <div class="home__overview__grid-item__wrap">
              <div class="home__overview__grid-item__content">
                <font-awesome-icon
                  icon="upload"
                  class="home__overview__grid-item__image"
                />
                <p v-t="'p.home.section.overview.message.upload'" />
              </div>
            </div>
          </div>
          <div class="home__overview__grid-item  col-xs-12 col-sm-6 col-xl-3">
            <div class="home__overview__grid-item__wrap">
              <div class="home__overview__grid-item__content">
                <font-awesome-icon
                  icon="film"
                  class="home__overview__grid-item__image"
                />
                <p v-t="'p.home.section.overview.message.embed'" />
              </div>
            </div>
          </div>
          <div class="home__overview__grid-item  col-xs-12 col-sm-6 col-xl-3">
            <div class="home__overview__grid-item__wrap">
              <div class="home__overview__grid-item__content">
                <font-awesome-icon
                  icon="paper-plane"
                  class="home__overview__grid-item__image"
                />
                <p v-t="'p.home.section.overview.message.newsletter'" />
              </div>
            </div>
          </div>
          <div class="home__overview__grid-item  col-xs-12 col-sm-6 col-xl-3">
            <div class="home__overview__grid-item__wrap">
              <div class="home__overview__grid-item__content">
                <font-awesome-icon
                  icon="comments"
                  class="home__overview__grid-item__image"
                />
                <p v-t="'p.home.section.overview.message.comment'" />
              </div>
            </div>
          </div>
          <div class="home__overview__grid-item  col-xs-12 col-sm-6 col-xl-3">
            <div class="home__overview__grid-item__wrap">
              <div class="home__overview__grid-item__content">
                <font-awesome-icon
                  icon="chart-pie"
                  class="home__overview__grid-item__image"
                />
                <p v-t="'p.home.section.overview.message.anonym'" />
              </div>
            </div>
          </div>
          <div class="home__overview__grid-item  col-xs-12 col-sm-6 col-xl-3">
            <div class="home__overview__grid-item__wrap">
              <div class="home__overview__grid-item__content">
                <font-awesome-icon
                  icon="users"
                  class="home__overview__grid-item__image"
                />
                <p v-t="'p.home.section.overview.message.roles'" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      id="home-guarantee"
      class="home__section home__guarantee"
    >
      <div class="container">
        <div class="home__section-row">
          <div class="col-xs-12 col-sm-2 col-md-3 col-lg-3 col-xl-2 offset-xl-2">
            <div class="home__guarantee__image">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="123"
                height="123"
              >
                <g
                  fill="none"
                  fill-rule="evenodd"
                >
                  <path
                    fill="#FFF"
                    d="M52.9 59.82h17.46v-6.55c0-4.8-3.92-8.72-8.72-8.72a8.74 8.74 0 0 0-8.73 8.72v6.55zm28.37 3.27v19.64c0 1.8-1.46 3.27-3.27 3.27H45.27A3.27 3.27 0 0 1 42 82.73V63.09c0-1.8 1.47-3.27 3.27-3.27h1.1v-6.55C46.36 44.9 53.24 38 61.63 38c8.38 0 15.27 6.89 15.27 15.27v6.55H78c1.8 0 3.27 1.46 3.27 3.27z"
                  />
                  <path
                    stroke="#FEFEFE"
                    stroke-width="3"
                    d="M41.19 2C39.59 2 2 2.5 2 41.19V81.8c0 1.6.5 39.19 39.19 39.19H81.8c1.6 0 39.19-.5 39.19-39.19V41.2C121 39.59 120.5 2 81.81 2H41.2z"
                  />
                </g>
              </svg>
            </div>
          </div>
          <div class="col-xs-12 col-sm-9 col-md-9 col-lg-8 col-xl-6">
            <div class="home__guarantee__details">
              <h2
                v-t="'p.home.section.guarantee.title'"
                class="home__guarantee__headline home__typo-h2"
              />
              <p
                v-t="'p.home.section.guarantee.message.description'"
                class="home__guarantee__text home__typo-text"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      id="home-demo"
      class="home__section home__demo background-muted"
    >
      <div class="container">
        <div class="home__section-row">
          <div class="col-lg-6 col-xl-5 offset-xl-1">
            <h2
              v-t="'p.home.section.demo.title'"
              class="home__demo__headline"
            />
            <p
              v-t="'p.home.section.demo.message.description'"
              class="home__demo__text home__typo-text"
            />
          </div>
          <div class="col-lg-6 col-xl-5">
            <form-wrap @submit="handleSubmit">
              <form-field-set :should-show-border="false">

                <text-input
                  v-model="company"
                  :error="fieldError('create', 'company')"
                  :label="$t('c.demoForm.form.label.company')"
                  :label-visible="false"
                  :placeholder="$t('c.demoForm.form.placeholder.company')"
                  name="company"
                  type="text"
                  direction="vertical"
                />

                <text-input
                  v-model="name"
                  :error="fieldError('create', 'name')"
                  :label="$t('c.demoForm.form.label.name')"
                  :label-visible="false"
                  :placeholder="$t('c.demoForm.form.placeholder.name')"
                  name="name"
                  type="text"
                  direction="vertical"
                />

                <text-input
                  v-model="email"
                  :error="fieldError('create', 'email')"
                  :label="$t('c.demoForm.form.label.email')"
                  :label-visible="false"
                  :placeholder="$t('c.demoForm.form.placeholder.email')"
                  name="email"
                  type="text"
                  direction="vertical"
                />

                <text-input
                  v-model="phone"
                  :error="fieldError('create', 'phone')"
                  :label="$t('c.demoForm.form.label.phone')"
                  :label-visible="false"
                  :placeholder="$t('c.demoForm.form.placeholder.phone')"
                  name="phone"
                  type="text"
                  direction="vertical"
                />

              </form-field-set>

              <form-actions
                :hide-spacer="true"
              >
                <button-input
                  :is-disabled="!isSaveable"
                  type="submit"
                >
                  <font-awesome-icon icon="arrow-alt-circle-right" />
                  <span v-t="'c.demoForm.form.action.submit'" />
                </button-input>
              </form-actions>
            </form-wrap>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR
} from 'store/modules/notifications/types'

export default {
  mixins: [FormMixin],
  components: {
    FontAwesomeIcon
  },
  computed: {
    ...mapGetters ({
      fieldError: 'demoForm/fieldError',
      isSaveable: 'demoForm/isSaveable'
    }),
    company: {
      get () { return this.$store.state.demoForm.form.company },
      set (value) { this.$store.dispatch('demoForm/setCompany', value) }
    },
    name: {
      get () { return this.$store.state.demoForm.form.name },
      set (value) { this.$store.dispatch('demoForm/setName', value) }
    },
    email: {
      get () { return this.$store.state.demoForm.form.email },
      set (value) { this.$store.dispatch('demoForm/setEmail', value) }
    },
    phone: {
      get () { return this.$store.state.demoForm.form.phone },
      set (value) { this.$store.dispatch('demoForm/setPhone', value) }
    },
    testimonial() {
      const index = Math.floor(Math.random() * Math.floor(this.$t('p.home.section.testimonials.item').length))
      let testimonial = this.$t(`p.home.section.testimonials.item[${index}]`)
      testimonial.imgSrc = require(`@/assets/images/${testimonial.avatar}`)
      return testimonial
    },
  },
  methods: {
    ...mapActions({
      customSubmit: 'demoForm/customSubmit',
      resetForm: 'demoForm/reset',
      addNotification: 'addNotification'
    }),
    handleSubmit () {
      this.customSubmit()
        .then(() => {
          this.addNotification({
            message: this.$t('p.home.section.demo.form.successMsg'),
            type: NOTIFICATION_TYPE_SUCCESS
          })
          this.resetForm()
        })
    }
  },
  created () {
    this.$emit('loadingDone')
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.home
  &__section
    padding: 100px 0
    +respond-max($sm)
      padding: $grid-gutter-width 0
    &.background-muted
      background-color: #fafafa
    &-row
      display: flex
      flex-direction: row
      flex-wrap: wrap
      margin: 0 (-$grid-gutter-width/2)
    &-heading
      margin-bottom: $grid-gutter-width
  &__typo
    &-h1
      margin: 0
      +font-size(64, 64)
      +respond-max($sm)
        +font-size(32, 32)
      font-weight: 900
    &-h2
      margin-top: 0
      margin-bottom: 15px
      +font-size(48, 50)
      +respond-max($sm)
        +font-size(30, 40)
      font-weight: 700
    &-text
      +font-size(18, 30)
      +respond-max($sm)
        +font-size(16, 24)
      font-weight: 300
      color: $color-grey-3
      word-break: break-word

  &__intro
    padding: 150px 0
    +respond-max($md)
      padding: 100px 0
    +respond-max($sm)
      padding: $grid-gutter-width 0
    &__image
      align-self: center
      text-align: center
      +respond-max($lg)
        display: none
    &__details
      align-self: center
      &__footer
        display: flex
        flex-direction: row
        flex-wrap: wrap
        align-items: baseline
        font-size: rem-calc(15)
        font-weight: 500
        color: $color-grey-3
        & > *
          margin-right: $grid-gutter-width
        & > span
          margin-top: $grid-gutter-width / 2
        .home__intro__button
          +respond-max($sm)
            width: 100%
            margin-right: 0
    &__text
      margin-top: $grid-gutter-width
      margin-bottom: 50px
      +respond-max($sm)
        margin-bottom: $grid-gutter-width
    &__button
      height: 60px
      padding: 0 30px
      font-size: 15px
      font-weight: 500
      line-height: 60px
      text-transform: uppercase

  &__testimonials
    &__quote
      padding: 80px 100px
      +font-size(18, 27)
      +respond-max($sm)
        +font-size(14, 21)
      font-style: italic
      color: $color-white
      background: $color-attention
      +respond-max($xl)
        padding: 40px 50px
      +respond-max($sm)
        padding: 30px 30px
    &__author
      position: relative
      display: flex
      flex-direction: row
      align-items: center
      justify-content: flex-end
      padding-top: 50px
      +respond-max($lg)
        padding-top: 25px
      text-align: right
      +respond-max($sm)
        &::after
          position: absolute
          top: -10px
          right: $grid-gutter-width
          width: 20px
          height: 20px
          content: ""
          background: $color-attention
          transform: rotate(45deg)
      &__name
        +font-size(18, 27)
        font-weight: 700
        letter-spacing: 0
      &__position
        +font-size(14, 27)
        font-weight: 300
        letter-spacing: 0
      &__avatar
        position: relative
        margin-left: $grid-gutter-width
        +respond-max($sm)
          display: none
        &::after
          position: absolute
          top: -60px
          +respond-max($lg)
            top: -35px
          left: calc(50% - 10px)
          width: 20px
          height: 20px
          content: ""
          background: $color-attention
          transform: rotate(45deg)

  &__overview
    &__grid
      +font-size(16, 19)
      +respond-max($sm)
        +font-size(14, 17)
      color: $color-grey-2
      text-align: center
    &__grid-item
      padding: 25px
      &__wrap
        position: relative
        height: 100%
      // horizontal spacer
      &__wrap::after
        position: absolute
        top: 0
        right: -25px
        height: 100%
        content: ''
        border-right: 1px solid $color-border-1
      +respond-min($xl)
        &:nth-child(4n) &__wrap::after
          display: none
      +respond-max($xl)
        &:nth-child(2n) &__wrap::after
          display: none
      +respond-max($sm)
        &__wrap::after
          display: none
      // vertical spacer
      &__wrap::before
        position: absolute
        top: -25px
        left: 0
        width: 100%
        content: ''
        border-top: 0
      +respond-min($xl)
        &:nth-child(n+5) &__wrap::before
          border-top: 1px solid $color-border-1
      +respond-max($xl)
        &:nth-child(n+3) &__wrap::before
          border-top: 1px solid $color-border-1
      +respond-max($sm)
        &:nth-child(n+2) &__wrap::before
          border-top: 1px solid $color-border-1
      &__content
        padding: 40px 0
        +respond-max($sm)
          padding: 10px 0
      &__image
        margin-bottom: $grid-gutter-width
        font-size: rem-calc(48)
        +respond-max($sm)
          font-size: rem-calc(30)

  &__guarantee
    color: $color-white
    background-color: $color-1
    &__image
      height: 61px
      svg
        transform-origin: top left
        +respond-max($md)
          transform: scale(.6)
        +respond-max($sm)
          transform: scale(.5)
    &__headline
      margin: 0
      line-height: rem-calc(70)
      color: $color-white
    &__text
      color: $color-white

  &__demo
    &__headline
      margin: 0 0 $grid-gutter-width/2 0
      +font-size(56, 56)
      +respond-max($sm)
        +font-size(32, 32)
      letter-spacing: 0

</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue